import { SettingsService } from '../../../../services/settings-service';
import { debounce } from 'ts-debounce';
import { DataService } from '../../../../services/utilities/data.service';
import { Consent } from '../../../../dataTypes/type-consent';
import { ConsentsStatusService } from '../../../../services/consents-services/consents-status.service';
import { GetConsentsService } from '../../../../services/consents-services/get-consents.service';
import { ConsentsToggleService } from '../../../../services/consents-services/consents-toggle-detail.service';
import { UtilityService } from '../../../../services/utility.service';
import UserCentricViewController from '../../usercentrics-view-controller';

const selectAllItemClassName = 'uc-select-all-items';
const _ = require('lodash');

const stateName = 'secondaryBasicPrivacyView';

const showPrimaryViewСlassName = 'show-primary-view';

const changeSecondaryStateBtnId = 'change-secondary-state';

const closeBtnClassName = 'close-modal-btn';
const cancelBtnClassName = 'cancel-modal-btn';
const saveInfoBtnClassName = 'uc-save-settings-button';
const openConsentInfoModalEventName = 'open-consent-info-modal';


const centerModalSecondaryBasicPrivacyTemplate1 = require('./templates/privacy-center-modal-templates/secondary-basic-privacy-center-modal-template-1.hbs');
const centerModalSecondaryBasicPrivacyTemplate11 = require('./templates/privacy-center-modal-templates/secondary-basic-privacy-center-modal-template-11.hbs');

export default class SecondaryBasicPrivacyViewController {
    private modalScope: any;
    private layoutParams: any;
    private languageService: any;
    private utilityService: UtilityService;
    private settingsService: SettingsService;

    private activeCategory: any;

    private isVisible: boolean;
    private showPrimaryViewBtns: any;
    private showSecondaryAdvanceViewBtns: any;

    private saveInfoBtns: any;
    private closeBtns: any;
    private cancelBtns: any;
    private categories: Consent.Category[];

    constructor(mainViewContoller, modalScope, layoutParams, utilityService) {
        this.layoutParams = layoutParams;
        this.languageService = utilityService.languageService;
        this.utilityService = utilityService;

        this.modalScope = modalScope;
        this.settingsService = utilityService.settingsService;

        this.isVisible = this.settingsService.centerModalVisibility;
        this.initActiveCategory();
    }

    private initActiveCategory() {
        this.activeCategory = _.find(this.categories, { active: true }) || {};
    }

    private setState() {
        this.modalScope.changeState(stateName);
    }

    private getHtml() {
        ConsentsStatusService.setSelectAllCategoryState();
        this.categories = DataService.categories;
        let viewHTML: any;
        switch (this.layoutParams.modalView) {
            case 'center-modal-template-1':
            case 'center-modal-template-2':
            case 'center-modal-template-3':
            case 'center-modal-template-4':
            case 'center-modal-template-5':
            case 'center-modal-template-6':
            case 'center-modal-template-7':
            case 'center-modal-template-8':
            case 'center-modal-template-9':
            case 'center-modal-template-10':
            case 'center-modal-template-12':
                viewHTML = centerModalSecondaryBasicPrivacyTemplate1;
                break;
            case 'center-modal-template-11':
                viewHTML = centerModalSecondaryBasicPrivacyTemplate11;
                break;
            default:
                viewHTML = centerModalSecondaryBasicPrivacyTemplate1;
                break;
        }
        let areConsentsChanged = false;
        const changedConsents = ConsentsStatusService.getConsentsThatHaveChanged(DataService.consents);
        if (changedConsents && changedConsents.length) {
            areConsentsChanged = true;
        }
        const optInConsent = GetConsentsService.getOptinConsent();
        let bgData = {
            darken: 0,
            overlayBackground: false,
            clickToClose: false,
        };
        if (this.utilityService.bgOverlayService) {
            const modalView = this.layoutParams.modalView.substring(0, 12) === 'center-modal' ? 'centralModal' : 'cornerModal';
            bgData = this.utilityService.bgOverlayService.getOverlayProperty(modalView);
        }
        return viewHTML({
            optInConsent: optInConsent,
            consentTemplates: DataService.consentTemplates,
            languageControl: this.modalScope.getModalWrapperElement()
                ? this.languageService.htmlString(this.modalScope.getModalWrapperElement().id)
                : this.languageService.htmlString(),
            categories: this.categories,
            settings: this.settingsService.settings,
            secondaryBasicVisible: this.visible,
            secondaryAdvanceVisible: this.modalScope.secondaryAdvancePrivacyViewController.visible,
            elementsVisibility: this.settingsService.elementsVisibility,
            allStatuses: ConsentsStatusService.selectAllStatus.categories.status,
            allStatusesIntermediate: ConsentsStatusService.selectAllStatus.categories.isIntermediateState,
            areConsentsChanged: areConsentsChanged,
            icons: UserCentricViewController.icons,
            bgData: bgData
        });
    }

    public updateSelectedStatusForAllCategories = debounce(
        function (status?) {
            DataService.consents.forEach((consent) => {
                ConsentsStatusService.setUnsavedConsentStatus(consent, status);
            });
            this.modalScope.updateView();
        },
        50,
        { isImmediate: false }
    );

    public initHandling() {
        if (this.isVisible) {
            this.initActiveCategory();
            const modalWrapperElement = this.modalScope.getModalWrapperElement();
            if (this.isVisible && modalWrapperElement) {
                const openConsentInfoModalBtns = modalWrapperElement.querySelectorAll(
                    '[data-event=' + openConsentInfoModalEventName + ']'
                );
                Array.prototype.forEach.call(openConsentInfoModalBtns, openConsentInfoModalBtn => {
                    if (openConsentInfoModalBtn) {
                        openConsentInfoModalBtn.addEventListener('click', (event) => {
                            if (openConsentInfoModalBtn.getAttribute('data-id')) {
                                this.openConsentInfoModal(
                                    openConsentInfoModalBtn.getAttribute('data-id')
                                );
                            } else {
                                this.openConsentInfoModal();
                            }
                        });
                    }
                });

                const selectAllItemElement = modalWrapperElement.getElementsByClassName(
                    selectAllItemClassName
                );
                _.forEach(selectAllItemElement, elem => {
                    if (elem) {
                        elem.onclick = (event: any) => {
                            event.preventDefault();
                            event.stopPropagation();
                            // const selectedElem = <HTMLFormElement> document.getElementById(
                            // 	'uc-btn-toggle-consents-select-all-corner-modal'
                            // );
                            // selectedElem['checked'] = !selected;
                            this.updateSelectedStatusForAllCategories(!ConsentsStatusService.selectAllStatus.status);
                        };
                    }
                });
                _.forEach(this.categories, (category: any) => {
                    const categoryId = category.categorySlug;

                    const categoryElement = modalWrapperElement.querySelector('#uc-category-' + categoryId);
                    const consentElements = modalWrapperElement.getElementsByClassName('consent-item');
                    const toggleCategoryElements = modalWrapperElement.getElementsByClassName(
                        'toggle-category-' + categoryId
                    );
                    const checkboxForCategoryToggling = modalWrapperElement.getElementsByClassName(
                        'checkbox-toggle-category-' + categoryId
                    );
                    const changeSecondaryStateBtn = modalWrapperElement.querySelector('#' + changeSecondaryStateBtnId);
                    const categoryToggleBtn = modalWrapperElement.querySelector('#category-toggle-' + categoryId);
                    const checkboxElm = modalWrapperElement.querySelector('#category-checkbox-' + categoryId);

                    if (categoryToggleBtn && !category.isEssential) {
                        categoryToggleBtn.onclick = (event: any) => {
                            // event.preventDefault();
                            event.stopPropagation();
                            checkboxElm.checked = !checkboxElm.checked;
                            this.updateSelectedStatusForCategory(category, checkboxElm.checked);
                        };
                    }

                    if (changeSecondaryStateBtn) {
                        changeSecondaryStateBtn.onclick = (event: any) => {
                            if (this.visible) {
                                const switchElements = changeSecondaryStateBtn.getElementsByClassName('switch1');
                                if (switchElements[0].classList.contains('on')) {
                                    switchElements[0].classList.add('off');
                                    switchElements[0].classList.remove('on');
                                } else {
                                    switchElements[0].classList.add('on');
                                    switchElements[0].classList.remove('off');
                                }
                                this.showSecondaryAdvanceView(switchElements[0].classList.contains('on'));
                            }
                        };
                    }

                    if (categoryElement) {
                        categoryElement.onclick = (event: any) => {
                            this.showHideDescriptionForCategory(category);
                        };
                    }

                    _.forEach(toggleCategoryElements, toggleElm => {
                        if (toggleElm) {
                            toggleElm.onclick = (event: any) => {
                                _.forEach(checkboxForCategoryToggling, checkboxElm => {
                                    checkboxElm.checked = !checkboxElm.checked;
                                });
                                this.updateSelectedStatusForCategory(category);
                            };
                        }
                    });
                });

                this.showPrimaryViewBtns = modalWrapperElement.getElementsByClassName(showPrimaryViewСlassName);
                _.forEach(this.showPrimaryViewBtns, showPrimaryViewBtn => {
                    if (showPrimaryViewBtn) {
                        showPrimaryViewBtn.onclick = (event: any) => {
                            this.showPrimaryView();
                        };
                    }
                });

                this.cancelBtns = modalWrapperElement.getElementsByClassName(cancelBtnClassName);
                _.forEach(this.cancelBtns, cancelBtn => {
                    if (cancelBtn) {
                        cancelBtn.onclick = (event: any) => {
                            this.cancel();
                        };
                    }
                });

                this.closeBtns = modalWrapperElement.getElementsByClassName(closeBtnClassName);
                _.forEach(this.closeBtns, closeBtn => {
                    if (closeBtn) {
                        closeBtn.onclick = (event: any) => {
                            this.cancel();
                        };
                    }
                });

                this.saveInfoBtns = modalWrapperElement.getElementsByClassName(saveInfoBtnClassName);
                _.forEach(this.saveInfoBtns, saveInfoBtn => {
                    if (saveInfoBtn) {
                        saveInfoBtn.onclick = (event: any) => {
                            this.saveAndClose();
                        };
                    }
                });
            }

            const overlays = modalWrapperElement.getElementsByClassName('inactive-background');
            let bgData = {
                darken: 0,
                overlayBackground: false,
                clickToClose: false,
            };
            if (this.utilityService.bgOverlayService) {
                const modalView = this.layoutParams.modalView.substring(0, 12) === 'center-modal' ? 'centralModal' : 'cornerModal';
                bgData = this.utilityService.bgOverlayService.getOverlayProperty(modalView);
            }
            Array.prototype.forEach.call(overlays, closeBtn => {
                if (bgData.clickToClose) {
                    closeBtn.addEventListener('click', (event: Event) => {
                        // make sure the click was on the background
                        if (event.target === closeBtn) {
                            this.cancel();
                        }
                    });
                }
            });
        }
    }

    public openConsentInfoModal(id?) {
        this.utilityService.moreInfoEventsService.openConsentInfoModal(id);
    }

    public updateSelectedStatusForConsent = debounce(function (consent, status?) {
        ConsentsStatusService.setUnsavedConsentStatus(consent, status != undefined ? status : !consent.status);
        this.modalScope.updateView();
    }, 500);

    public updateSelectedStatusForCategory = debounce(function (category, status?) {
        ConsentsStatusService.changeCategorySelectedStatus(category, status != undefined ? status : !category.status);
        this.modalScope.updateView();
    }, 100);

    public showPrimaryView() {
        this.modalScope.changeState('primary');
        this.modalScope.updateView();
    }

    public showSecondaryAdvanceView = debounce(function (isShow) {
        if (isShow) {
            ConsentsToggleService.resetConsentActiveStatus();
            this.modalScope.changeState('secondary-advance');
        }
    }, 500);

    public cancel() {
        ConsentsStatusService.resetAllConsents(DataService.consents);
        this.modalScope.closeModal();
    }

    public saveAndClose() {
        const action = 'onSaveBtnClick';
        const updatedBy = 'explicit';
        this.utilityService.saveConsentsService.saveConsents(action, updatedBy);
        this.settingsService.saveFirstUserInteraction();
        this.modalScope.closeModal();
    }

    public showHideDescriptionForCategory(category) {
        ConsentsToggleService.changeCategoryShowDetailStatus(category, !category.showDetail);
        this.modalScope.updateView();
    }

    public set visible(_visible) {
        this.isVisible = _visible;
    }

    public get visible() {
        return this.isVisible;
    }

    public get htmlString(): string {
        if (this.isVisible) {
            return this.getHtml();
        }
        return '';

    }
}
